import { useLazyGetCartFromDBQuery } from "app/api/cart/cartApi";
import { setAppCookie } from "utilities/cookies";
import { COOKIE_CART_ID } from "utilities/consts";
import { useDispatch, useSelector } from "redux/hooks";
import { updateCart } from "redux/cart/cartSlice";

const useCartOnLogin = () => {
  const [triggerGetCartFromDB] = useLazyGetCartFromDBQuery();

  const dispatch = useDispatch();
  const currentCart = useSelector((state) => state.cart.cart);

  const fetchCart = async (customerId: number, storeHash: string) => {
    try {
      // If the user already has an anonymous cart active, keep it —
      // updateCartCustomer in useCart will assign it to the customer.
      if (currentCart?.id && currentCart.customer_id === 0) {
        return null;
      }

      const cart = await triggerGetCartFromDB(customerId).unwrap();

      if (cart?.id) {
        await setAppCookie(
          COOKIE_CART_ID,
          { id: cart.id, customer: customerId, storeHash },
          () => new Date(Date.now() + 1000 * 60 * 60 * 24 * 30) 
        );

        dispatch(updateCart(cart));

      }

      return cart;
    } catch (err) {
      console.error("Failed to fetch cart on login:", err);
      return null;
    }
  };

  return { fetchCart };
};

export default useCartOnLogin;
